import React, { useState, useEffect } from "react";
import "./books.css";
import CommonObj from "../../CommonObj";
import { useAuthToken } from "../../components/usecontext/AuthContext";
import Html5QrcodePlugin from "../qrscanner/qrscanner";
import { useNavigate, useLocation } from "react-router-dom";
import { Modal } from "antd";
import { message } from "../../components/antdMessageBridge";
import BookShelf from "../../images/book.svg";
import SliderUI from "../manifest/manifest-slide";
import BookCoverDummy from "../../assets/img/cover.png";
import { Html5QrcodeScanType } from "html5-qrcode";
import { useAuth } from "../../auth/AuthContext";
import { encryptTimestamp } from "../../components/commoncsrf/csrf-common";
import regexService from "../../components/commonregex/regexService";
import validationService from "../../components/commonvalidation/validationService";

const MyForm = () => {
    const location = useLocation();
    const bkey = location?.state?.key || {};
    const [form, setForm] = useState({
        bid: bkey ? bkey : "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        weight: "",
        isbn: "",
        condition: "",
        bookType: "",
        usedCondition: "Acceptable",
        content: "",
        bookFormat: "",
        //  eqComplexityLevel: "",
        comments: "",
        reasonForException: "",
        rackAndShelf: "",
        rackShelf: "",
        version: "",
    });
    const initialFormState = {
        bid: "",
        title: "",
        author: "",
        publisher: "",
        isbN10: "",
        isbN13: "",
        bookPageCount: "",
        language: "",
        weight: "",
        isbn: "",
        condition: "",
        bookType: "",
        usedCondition: "",
        content: [],
        bookFormat: "",
        eqComplexityLevel: "",
        rackAndShelf: "",
        comments: "",
        reasonForException: "",
        rackShelf: "",
        version: "1.0",
    };
    const [masterData, setMasterData] = useState({
        bookFormat: [],
        condition: [],
        eqComplexityLevelFormula: [],
        bookFormatExceptions: [],
        bookType: [],
        usedCondition: [],
        bookCondition: [],
        language: [],
    });
    const [languageData, setLanguageData] = useState([]);

    const { accessToken, isAuthenticated } = useAuthToken();
    const [visible, setVisible] = useState(false);
    const { roleUserId } = useAuth();
    const [commentsvisible, setCommentsVisible] = useState(false);
    const [bookCover, setBookCover] = useState("");
    const [commentsList, setCommentsList] = useState([]);
    const [currentBidForComments, setCurrentBidForComments] = useState("");
    const [hasUserInteracted, setHasUserInteracted] = useState(false);
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [activeScanner, setActiveScanner] = useState(null);
    const [decodedResults, setDecodedResults] = useState([]);
    const [load, setLoad] = useState(false);
    const [regexLoaded, setRegexLoaded] = useState(false);
    const [langErrorMsg, setLangErrorMsg] = useState("");

    const [selectedLanguage, setSelectedLanguage] = useState("");
    const UserDetails = JSON.parse(localStorage.getItem("user"));
    const LogoText = UserDetails?.name?.toUpperCase() || "U";
    useEffect(() => {
        const fetchMasterData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetMasterData, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setMasterData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };


        fetchMasterData();
        const fetchBookData = async () => {
            if (bkey != "") {
                try {
                    const payload = {
                        bid: bkey,
                    };
                    const myHeaders = {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    };
                    const response = await fetch(CommonObj.Endpoints.GetBookinfoByBID, {
                        method: "POST",
                        headers: myHeaders,
                        body: JSON.stringify(payload),
                    });
                    if (!response.ok) {
                        throw new Error(`HTTP error! Status: ${response.status}`);
                    }
                    const data = await response.json();
                    const bookDetails = data[0];
                    if (data[0]) {
                        setErrors({});
                        setForm({
                            ...form,
                            bid: bookDetails.bid,
                            title: bookDetails.title,
                            author: bookDetails.author,
                            publisher: bookDetails.publisher,
                            isbN10: bookDetails.isbN10,
                            isbN13: bookDetails.isbN13,
                            bookPageCount: bookDetails.pageCount,
                            language: bookDetails.language,
                            weight: bookDetails.weight?.trim() || "0.75",
                            isbn: bookDetails.isbn,
                            bookFormat: bookDetails.format,
                            condition: bookDetails.condition,
                            usedCondition: bookDetails.usedCondition,
                            reasonForException: bookDetails.reasonForException,
                            eqComplexityLevel: bookDetails.eqComplexityLevel,
                            content: bookDetails?.content?.split(","),
                            rackShelf: bookDetails.rackShelf,
                            bookType: bookDetails.bookType,
                            version: bookDetails.version,
                        });
                        setBookCover(bookDetails.bookCoverImageURL);
                        fetchCommentCount(bookDetails.bid);
                        setSelectedLanguage(bookDetails.language);
                    }
                } catch (error) {
                    console.error("Failed to fetch master data:", error);
                }
            }
        };

        fetchBookData();
    }, []);

    const isLanguageInactive = (langName) => {
        if (!langName || !Array.isArray(languageData)) return false;
        const matched = languageData.find(
            (ld) =>
                ld.languageName?.toLowerCase() === langName.toLowerCase() ||
                ld.languageCode?.toLowerCase() === langName.toLowerCase()
        );
        if (matched) {
            return (
                matched.status === "0"
            );
        }
        return false;
    };
    useEffect(() => {
        if (selectedLanguage && languageData.length > 0) {
            if (isLanguageInactive(selectedLanguage)) {
                message.warning("This language is currently inactive.");
            }
        }
    }, [selectedLanguage, languageData]);


    useEffect(() => {
        const fetchLanguageData = async () => {
            try {
                const response = await fetch(CommonObj.Endpoints.GetLanguageListwithCode, {
                    method: "GET",
                    mode: "cors",
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                        "X-CSRF-Token": encryptTimestamp(),
                        "Content-Type": "application/json",
                    },
                });


                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                const data = await response.json();
                setLanguageData(data);
            } catch (error) {
                console.error("Failed to fetch master data:", error);
            }
        };

        fetchLanguageData();
    }, []);

    useEffect(() => {
        const loadRegexPatterns = async () => {
            try {
                await regexService.fetchRegexData(accessToken);
                await validationService.fetchRegexData(accessToken);
                setRegexLoaded(true);
            } catch (error) {
                console.error("Failed to load regex patterns:", error);
            }
        };

        if (accessToken) {
            loadRegexPatterns();
        }
    }, [accessToken]);

    useEffect(() => {
        if (
            !form.bookFormat ||
            form?.content?.length === 0 ||
            masterData.eqComplexityLevelFormula.length === 0
        ) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
            return;
        }

        const bookFormatObj = masterData.bookFormat.find(
            (bf) => bf.format === form.bookFormat
        );
        if (!bookFormatObj) return;

        const selectedConditionIds =
            Array.isArray(form?.content) &&
            form?.content?.length > 0 &&
            form?.content
                ?.map((contentName) => {
                    const conditionObj = masterData?.condition?.find(
                        (c) => c?.fileType === contentName
                    );
                    return conditionObj ? conditionObj?.id?.toString() : null;
                })
                .filter((id) => id !== null);

        let bestMatch = null;
        for (const formula of masterData.eqComplexityLevelFormula) {
            if (formula.bookFormat !== bookFormatObj.id.toString()) {
                continue;
            }

            const formulaConditions = formula.condition.split(",");

            if (
                formulaConditions?.length === selectedConditionIds?.length &&
                formulaConditions?.every((condId) =>
                    selectedConditionIds?.includes(condId)
                )
            ) {
                bestMatch = formula;
                break;
            }
        }

        if (bestMatch) {
            setForm((prev) => ({ ...prev, eqComplexityLevel: bestMatch.level }));
            setErrors(prev => ({
                ...prev,
                ['eqComplexityLevel']: ""
            }));
        } else {
            setForm((prev) => ({ ...prev, eqComplexityLevel: "" }));
        }
    }, [form.bookFormat, form.content, masterData]);
    // useEffect(() => {

    // });
    const handleContentChange = (e) => {
        const { name, value, checked } = e.target;

        setForm((prev) => {
            const currentContent = prev.content;

            if (checked) {
                return { ...prev, content: [...(currentContent || []), value] };
            } else {
                return {
                    ...prev,
                    content: currentContent.filter((item) => item !== value),
                };
            }
        });
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };
    const openCommentsSlider = async (bid) => {
        if (!bid) {
            message.warning("Please enter BID before viewing comments.");
            return;
        }

        setCurrentBidForComments(bid);
        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data || []);
            setCommentsVisible(true);
        } catch (error) {
            message.error(`Failed to fetch comments: ${error.message}`);
        }
    };

    const saveComment = async () => {
        if (!currentBidForComments.trim()) {
            message.warning("No BID selected for saving comments.");
            return;
        }
        if (!form.comments.trim()) {
            message.warning("Please enter a comment before saving.");
            return;
        }
        const commentError = validationService.validateComments(form.comments);
        if (commentError) {
            message.warning(commentError);
            return;
        }
        const payload = {
            bid: currentBidForComments,
            //process: 3,
            //status: 7,
            comments: form.comments || LogoText,
            createdBy: roleUserId,
        };
        setLoad(true)
        try {
            const response = await fetch(CommonObj.Endpoints.InsertComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            if (!response.ok) {
                const result = await response.json();
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }

            message.success("Comment saved successfully!");
            setForm((prev) => ({ ...prev, comments: "" }));

            openCommentsSlider(currentBidForComments);
        } catch (error) {
            message.error({ content: error.message, duration: 5 });
        } finally {
            setLoad(false)
        }
    };
    function filterUniqueScans(results) {
        const filteredResults = [];
        if (results.length === 0) {
            return filteredResults;
        }
        filteredResults.push(results[0]);
        for (let i = 1; i < results.length; ++i) {
            if (results[i].decodedText !== results[i - 1].decodedText) {
                filteredResults.push(results[i]);
            }
        }
        return filteredResults;
    }
    const [selectedValues, setSelectedValues] = useState([]);

    const handleChanged = (value) => {
        setSelectedValues(value);
    };

    const handleGoToAbout = () => navigate("/activequeue");
    const handleGoBack = () => navigate(-1);

    useEffect(() => {
        const uniqueResults = filterUniqueScans(decodedResults);

        if (uniqueResults.length > 0 && activeScanner) {
            const latestResult = uniqueResults[uniqueResults.length - 1];
            const scannedValue = latestResult.decodedText;
            switch (activeScanner) {
                case "isbn":
                    setForm((prev) => ({ ...prev, isbn: scannedValue }));

                    break;
                case "bid":
                    setForm((prev) => ({ ...prev, bid: scannedValue }));
                    break;
                case "Rack & Shelf ID":
                    setForm((prev) => ({ ...prev, rackShelf: scannedValue }));
                    break;
                default:
                    break;
            }
            setActiveScanner(null);
            setDecodedResults([]);
        }
    }, [decodedResults, activeScanner]);

    const onNewScanResult = (decodedText, decodedResult) => {
        setDecodedResults((prev) => [...prev, decodedResult]);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;

        setForm((prev) => {
            const updatedForm = { ...prev, [name]: value };
            if (name === "bookFormat" && value === "Exceptions") {
                //  updatedForm.eqComplexityLevel = "";
            }
            if (name === "condition" && value === "Used Condition") {
                updatedForm.usedCondition = "Acceptable";
            } else if (name === "condition" && value === "New Book") {
                updatedForm.usedCondition = "";
            }
            return updatedForm;
        });

        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validate = () => {
        const newErrors = {};

        const isbnVal = form.isbn?.trim();
        //if (isbnVal) {
            const isbnResult = validationService.validateISBN(isbnVal);
            if (!isbnResult.isValid) newErrors.isbn = isbnResult.error;
        //}

        const isbn10Val = form.isbN10?.trim();
        //if (isbn10Val) {
            const isbn10Result = validationService.validateISBN10(isbn10Val);
            if (!isbn10Result.isValid) newErrors.isbN10 = isbn10Result.error;
        //}

        const isbn13Val = form.isbN13?.trim();
        //if (isbn13Val) {
            const isbn13Result = validationService.validateISBN13(isbn13Val);
            if (!isbn13Result.isValid) newErrors.isbN13 = isbn13Result.error;
        //}
        const titleError = validationService.validateTitle(form.title);
        if (titleError) newErrors.title = titleError === "Title is required" ? "Please Enter Title of the Book" : titleError;

        const authorError = validationService.validateAuthor(form.author);
        if (authorError) newErrors.author = authorError === "Author is required" ? "Please Enter Author of the Book" : authorError;

        const publisherError = validationService.validatePublisher(form.publisher);
        if (publisherError) newErrors.publisher = publisherError === "Publisher is required" ? "Please Enter Publisher of the Book" : publisherError;

        const languageError = validationService.validateLanguage(selectedLanguage);
        if (languageError) newErrors.language = languageError;

        const conditionError = validationService.validateCondition(form.condition);
        if (conditionError) newErrors.condition = conditionError;

        const bookTypeError = validationService.validateBookType(form.bookType);
        if (bookTypeError) newErrors.bookType = bookTypeError;

        const bookFormatError = validationService.validateBookFormat(form.bookFormat);
        if (bookFormatError) newErrors.bookFormat = bookFormatError;

        const rackShelfError = validationService.validateRackAndShelf(form.rackShelf);
        if (rackShelfError) newErrors.rackShelf = rackShelfError;

        // Rack shelf regex validation
        if (!validationService.isMissing(form.rackShelf) && regexLoaded) {
            const val = regexService.validateRackShelf(form.rackShelf.trim());
            if (!val.isValid) newErrors.rackShelf = "Input format invalid: No matching pattern found.";
        }

        // Page count
        const pageCountResult = validationService.validatePageCount(form.bookPageCount);
        if (!pageCountResult.isValid) newErrors.bookPageCount = pageCountResult.error;

        // Content
        const contentError = validationService.validateContent(form.content);
        if (contentError) newErrors.content = contentError;

        // Conditional: Used Condition
        const usedConditionError = validationService.validateUsedCondition(form.usedCondition, form.condition);
        if (usedConditionError) newErrors.usedCondition = usedConditionError;

        // Conditional: EQ-Complexity or Exception
        const isException = form.bookFormat === "Exceptions";
        if (isException && validationService.isMissing(form.reasonForException)) {
            newErrors.reasonForException = "Reason for exception is required when book type is Exceptions";
        } else {
            const eqError = validationService.validateEQComplexityLevel(form.eqComplexityLevel, form.bookFormat);
            if (eqError) newErrors.eqComplexityLevel = eqError;
        }

        const weightResult = validationService.validateWeight(form.weight);
        if (!weightResult.isValid) newErrors.weight = weightResult.error;

        const commentError = validationService.validateComments(form.comments);
        if (commentError) {
            message.warning(commentError);
            return;
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const [isDisabled, setIsDisabled] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();

        setIsDisabled(true);
        setTimeout(() => setIsDisabled(false), 3000);

        if (!validate()) {
            const firstField = Object.keys(errors)[0];
            if (firstField) document.getElementById(firstField)?.focus();
            return;
        }

        await submitComments();

        const payload = prepareUpdatePayload();
        await executeUpdate(payload);
    };


    const submitComments = async () => {
        const { comments, bid } = form;
        if (!comments.trim() || !bid.trim()) return;
        const commentError = validationService.validateComments(comments);
        if (commentError) {
            message.warning(commentError);
            return;
        }
        const payload = {
            bid,
            comments,
            process: 3,
            status: 7,
            createdBy: roleUserId,
        };

        try {
            const response = await fetch(CommonObj.Endpoints.InsertComments, {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                const result = await response.json();
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
        } catch (err) {
            console.error("Comment save failed:", err.message);
            message.error({ content: err.message, duration: 5 });
        }
    };

    const prepareUpdatePayload = () => ({
        ...form,
        rackShelf: form.rackShelf.trim(),
        rackAndShelf: 1,
        pageCount: Number(form.bookPageCount),
        weight: form.weight?.trim(),
        format: form.bookFormat,
        usedCondition: form.usedCondition || '0',
        content: Array.isArray(form.content) ? form.content.join(",") : form.content,
        eqComplexityLevel: form.bookFormat !== "Exceptions" ? form.eqComplexityLevel : "undefined",
        formatException: Number(form.reasonForException) || 0,
        version: "1.0",
        createdBy: roleUserId,
        bookCoverImageURL: bookCover,
        language: selectedLanguage,
        comments: form.comments || LogoText,
    });

    const executeUpdate = async (payload) => {
        try {
            const response = await fetch(CommonObj.Endpoints.UpdateBookDetails, {
                method: "POST",
                headers: getAuthHeaders(),
                body: JSON.stringify(payload),
            });
            const result = await response.json();

            if (!response.ok) {
                const errorMessage = result.error || result.message || `Error ${response.status}`;
                throw new Error(errorMessage);
            }
            handleSuccess(payload);
        } catch (error) {
            message.error({ content: error.message, duration: 5 });
        }
    };

    const handleSuccess = (payload) => {
        const isUnacceptable = payload.condition === "Used Condition" && payload.usedCondition === "Unacceptable";

        if (isUnacceptable) {
            message.success("Book intake cancelled due to unacceptable wear level");
        } else {
            message.success(`Book Id : ${form.bid} has been Updated Successfully.`);
        }

        navigate("/activequeue");
        resetForm();
    };

    const getAuthHeaders = () => ({
        Authorization: `Bearer ${accessToken}`,
        "X-CSRF-Token": encryptTimestamp(),
        "Content-Type": "application/json",
    });

    const resetForm = () => {
        setForm(initialFormState); // Set this to your empty object constant
        setErrors({});
        setSelectedLanguage("");
    };
    const fetchCommentCount = async (bid) => {
        if (!bid) return;

        try {
            const response = await fetch(CommonObj.Endpoints.GetComments, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "X-CSRF-Token": encryptTimestamp(),
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    pageNo: 1,
                    pageSize: 10,
                    search: bid,
                }),
            });
            if (!response.ok) {
                throw new Error(`Status ${response.status}`);
            }
            const data = await response.json();
            setCommentsList(data);
        } catch (error) {
            console.error(`Failed to fetch comments: ${error.message}`);
        }
    };
    async function UserLogin(isbn) {
        const url = CommonObj.Endpoints.Books;
        let pageName = { isbn: isbn };
        try {
            const response = await fetch(url, {
                method: "POST",
                mode: "cors",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(pageName),
            });
            if (!response.ok) throw new Error(`Response status: ${response.status}`);
            const result = await response.json();
            if (result.bookData) {
                setErrors({});
                setForm({
                    ...form,
                    bid: result.bookData.bid || form.bid,
                    title: result.bookData.title,
                    author: result.bookData.author,
                    publisher: result.bookData.publisher,
                    isbN10: result.bookData.isbN10,
                    isbN13: result.bookData.isbN13,
                    bookPageCount: result.bookData.pageCount,
                    language: result.bookData.language,
                    weight: result.bookData.weight,
                    isbn: isbn,
                    bookFormat: result.bookData.bookFormat || form.bookFormat,
                    condition: result.bookData.condition || form.condition,
                    usedCondition: result.bookData.usedCondition || form.usedCondition,
                    reasonForException:
                        result.bookData.reasonForException || form.reasonForException,
                    eqComplexityLevel:
                        result.bookData.eqComplexityLevel || form.eqComplexityLevel,
                    content: result.bookData.content || form.content,
                    rackShelf: form.rackShelf,
                    bookType: result.bookData.bookType || form.bookType,
                    version: result.bookData.version || form.version,
                });
                setBookCover(result.bookData.bookCoverImageURL);
                setSelectedLanguage(result.bookData.language);
            }
        } catch (error) {
            console.error(error.message);
        }
    }

    const handleLanguageChange = (e) => {
        const { name, value } = e.target;
        if (errors[name]) {
            setErrors((prev) => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
        setSelectedLanguage(value);
        setForm((prev) => ({ ...prev, language: value }));
    }
    const isSelectedMissingFromMaster = selectedLanguage && !masterData.language.some(
        (lang) => lang.languageName === selectedLanguage
    );

    const handleBlur = (e) => {
        setHasUserInteracted(true);
        if (form.isbn && e.target.name === "isbn") {
            //   UserLogin(form.isbn);
        }
    };
    const getInputClass = (value, baseClass = "book-page-form-input-text") => {
        const hasValue =
            value !== null &&
            value !== undefined &&
            (typeof value === "number" || String(value).trim() !== "");

        return `${baseClass}${hasValue ? " has-text" : ""}`;
    };
    return (
        <>
            <Modal
                title={`Scan ${activeScanner ? activeScanner.toUpperCase() : ""}`}
                open={!!activeScanner}
                onCancel={() => setActiveScanner(null)}
                footer={null}
                destroyOnClose
                className="scan-model-container"
                width={1000}
            >
                <div className="scan-modal">
                    <Html5QrcodePlugin
                        fps={30}
                        qrbox={{ width: 1000, height: 400 }}
                        aspectRatio={2.8}
                        disableFlip={false}
                        qrCodeSuccessCallback={onNewScanResult}
                        supportedScanTypes={[Html5QrcodeScanType.SCAN_TYPE_CAMERA]}
                    />
                </div>
            </Modal>
            <SliderUI
                visible={visible}
                width={390}
                title="Book Slide"
                onClose={() => setVisible(false)}
                imageSrc={bookCover ? bookCover : BookCoverDummy}
                bookTitle={form.title}
                isbn={form.isbn}
                bid={form.bid}
                bookscover={true}
                className="story-slider"
            />
            <SliderUI
                visible={commentsvisible}
                width={390}
                title="Comments Slide"
                onClose={() => setCommentsVisible(false)}
                bookTitle={`Comments For BID : ${form.bid}`}
                commentsList={commentsList}
                commentsCount={commentsList.length > 0 ? commentsList[0].totalRows : 0}
                username={form.createdBy}
                form={form}
                setForm={setForm}
                saveComment={saveComment}
                load={load}
                className="story-slider"
            />
            {/*<Drawer
                visible={commentsvisible}
                width={320}
                title="Comments"
                onClose={() => setCommentsVisible(false)}
            >
                <div style={{ padding: 16 }}>
                    <div>
                        <strong>Comments for BID: {currentBidForComments}</strong>
                        <div
                            style={{
                                margin: "10px 0",
                                maxHeight: "180px",
                                overflowY: "auto",
                            }}
                        >
                            {commentsList.length > 0 ? (
                                commentsList?.map((comment, idx) => (
                                    <div
                                        key={idx}
                                        style={{
                                            marginBottom: 8,
                                            background: "#f4f4f4",
                                            padding: 8,
                                            borderRadius: 3,
                                        }}
                                    >
                                        {comment?.comments}
                                    </div>
                                ))
                            ) : (
                                <div>No Existing Comments</div>
                            )}
                        </div>
                        <Input.TextArea
                            rows={2}
                            value={form.comments}
                            placeholder="Enter your comment..."
                            onChange={(e) =>
                                setForm((prev) => ({ ...prev, comments: e.target.value }))
                            }
                            style={{ marginBottom: 8 }}
                        />
                        <Button type="primary" block onClick={saveComment}>
                            Post Comment
                        </Button>
                    </div>
                </div>
            </Drawer>*/}
            <main className="book-page-main-container">
                <div className="book-page-container">
                    <div className="book-page-title-container">
                        <div className="book-page-title">
                            <span>
                                <img src={BookShelf} alt="Bookself edit icon"></img>
                            </span>
                            <h2>Edit Intake Details</h2>
                        </div>
                        <button className="book-page-title-icon" onClick={() => setVisible(true)}>
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M4 6V19C4 20.6569 5.34315 22 7 22H17C18.6569 22 20 20.6569 20 19V9C20 7.34315 18.6569 6 17 6H4ZM4 6V5"
                                    stroke="#0009E2"
                                    strokeWidth="1.5"
                                />
                                <circle
                                    opacity="0.5"
                                    cx="12"
                                    cy="13"
                                    r="3"
                                    stroke="#009DDB"
                                    strokeWidth="1.5"
                                />
                                <path
                                    d="M18 6.00002V6.75002H18.75V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619H4.81353L4.91959 3.86865ZM5.07107 6.00002V6.75002H18V6.00002V5.25002H5.07107V6.00002ZM18 6.00002H18.75V4.30604H18H17.25V6.00002H18ZM15.7172 2.32614L15.6111 1.58368L4.81353 3.12619L4.91959 3.86865L5.02566 4.61111L15.8232 3.0686L15.7172 2.32614ZM4.91959 3.86865L4.81353 3.12619C3.91638 3.25435 3.25 4.0227 3.25 4.92895H4H4.75C4.75 4.76917 4.86749 4.63371 5.02566 4.61111L4.91959 3.86865ZM18 4.30604H18.75C18.75 2.63253 17.2678 1.34701 15.6111 1.58368L15.7172 2.32614L15.8232 3.0686C16.5763 2.96103 17.25 3.54535 17.25 4.30604H18ZM5.07107 6.00002V5.25002C4.89375 5.25002 4.75 5.10627 4.75 4.92895H4H3.25C3.25 5.9347 4.06532 6.75002 5.07107 6.75002V6.00002Z"
                                    fill="#0009E2"
                                />
                                <path
                                    opacity="0.5"
                                    d="M10 19H14"
                                    stroke="#009DDB"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </button>
                    </div>
                    <form className="book-page-form" onSubmit={handleSubmit} noValidate>
                        <div className="book-page-form-container">
                            <div className="book-page-form-1">
                                <div className="field-group">
                                    <input
                                        id="bid"
                                        name="bid"
                                        className={getInputClass(form?.bid)}
                                        value={form.bid}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        disabled
                                    />
                                    <label htmlFor="bid" className="label">
                                        Book Id (BID) <span className="form-required">*</span>
                                    </label>
                                </div>
                                <div className="field-group">
                                    <input
                                        id="main-isbn"
                                        name="isbn"
                                        className={getInputClass(form?.isbn)}
                                        value={form.isbn}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        required
                                    />
                                    <label htmlFor="main-isbn" className="label">
                                        Book Number (ISBN) <span className="form-required">*</span>
                                    </label>
                                    {errors.isbn && (
                                        <span className="error-msg">{errors.isbn}</span>
                                    )}
                                </div>

                                <div className="field-group" hidden>
                                    <input
                                        id="version"
                                        name="version"
                                        className={getInputClass(form?.version)}
                                        value={form.version}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="version" className="label">
                                        Version
                                    </label>
                                    {errors.version && (
                                        <span className="error-msg">{errors.version}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="isbN10"
                                        name="isbN10"
                                        className={getInputClass(form?.isbN10)}
                                        value={form.isbN10}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="isbN10" className="label">
                                        ISBN-10 <span className="form-required">*</span>
                                    </label>
                                    {errors.isbN10 && (
                                        <span className="error-msg">{errors.isbN10}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="isbN13"
                                        name="isbN13"
                                        className={getInputClass(form?.isbN13)}
                                        value={form.isbN13}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="isbN13" className="label">
                                        ISBN-13 <span className="form-required">*</span>
                                    </label>
                                    {errors.isbN13 && (
                                        <span className="error-msg">{errors.isbN13}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <input
                                        id="weight"
                                        name="weight"
                                        className={`${"book-page-form-input-text"} ${form.weight === "" ? "" : "has-text"
                                            }`}
                                        value={form.weight?.trim()}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="weight" className="label">
                                        Weight <span className="form-required">*</span>
                                    </label>
                                    {errors.weight && (
                                        <span className="error-msg">{errors.weight}</span>
                                    )}
                                </div>
                                {form.bookFormat !== "Exceptions" && (
                                    <div className="field-group">
                                        <select
                                            id="eqComplexityLevel"
                                            name="eqComplexityLevel"
                                            className={getInputClass(form?.eqComplexityLevel)}
                                            value={form.eqComplexityLevel || ""}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value=""> </option>
                                            {Array.from(
                                                new Set(
                                                    masterData.eqComplexityLevelFormula
                                                        .map(formula => formula.level)
                                                        .filter(level => level)
                                                )
                                            )
                                                .sort((a, b) => {
                                                    const numA = parseInt(a);
                                                    const numB = parseInt(b);
                                                    const letterA = a.slice(-1);
                                                    const letterB = b.slice(-1);

                                                    if (numA !== numB) return numA - numB;
                                                    return letterA.localeCompare(letterB);
                                                })
                                                .map(level => (
                                                    <option key={level} value={level}>
                                                        {level}
                                                    </option>
                                                ))}
                                        </select>
                                        <label htmlFor="eqComplexityLevel" className="label">
                                            EQ-Complexity Level <span className="form-required">*</span>
                                        </label>
                                        {errors?.eqComplexityLevel && (
                                            <span className="error-msg">{errors.eqComplexityLevel}</span>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="book-page-form-2">
                                <div className="field-group">
                                    <input
                                        id="title"
                                        name="title"
                                        className={getInputClass(form?.title)}
                                        value={form.title}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="title" className="label">
                                        Title <span className="form-required">*</span>
                                    </label>
                                    {errors.title && (
                                        <span className="error-msg">{errors.title}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="author"
                                        name="author"
                                        className={getInputClass(form?.author)}
                                        value={form.author}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="author" className="label">
                                        Author <span className="form-required">*</span>
                                    </label>
                                    {errors.author && (
                                        <span className="error-msg">{errors.author}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="publisher"
                                        name="publisher"
                                        className={getInputClass(form?.publisher)}
                                        value={form.publisher}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="publisher" className="label">
                                        Publisher <span className="form-required">*</span>
                                    </label>
                                    {errors.publisher && (
                                        <span className="error-msg">{errors.publisher}</span>
                                    )}
                                </div>

                                <div className="field-group">
                                    <input
                                        id="bookPageCount"
                                        name="bookPageCount"
                                        className={getInputClass(form?.bookPageCount)}
                                        type="number"
                                        value={form.bookPageCount}
                                        onChange={handleChange}
                                    />
                                    <label htmlFor="bookPageCount" className="label">
                                        Page Count <span className="form-required">*</span>
                                    </label>
                                    {errors.bookPageCount && (
                                        <span className="error-msg">{errors.bookPageCount}</span>
                                    )}
                                </div>
                                <div className="field-group">
                                    <select
                                        id="language"
                                        name="language"
                                        className={`book-page-form-input-text ${selectedLanguage ? "has-text" : ""}`}
                                        value={selectedLanguage}
                                        onChange={handleLanguageChange}
                                        required
                                    >
                                        <option value=""></option>
                                        {isSelectedMissingFromMaster && (
                                            <option value={selectedLanguage} disabled>
                                                {selectedLanguage}
                                            </option>
                                        )}
                                        {masterData.language.map((language) => {
                                            const isInactive = isLanguageInactive(language.languageName);
                                            const isCurrentlySelected = selectedLanguage === language.languageName;
                                            return (
                                                <option
                                                    key={language.languageName}
                                                    value={language.languageName || selectedLanguage}
                                                    disabled={language.status == 0}
                                                >
                                                    {language.languageName}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <label htmlFor="language" className="label">
                                        Language <span className="form-required">*</span>
                                    </label>
                                    {errors.language && !langErrorMsg && (
                                        <span className="error-msg">{errors.language}</span>
                                    )}
                                    {langErrorMsg && (
                                        <span className="error-msg">{langErrorMsg}</span>
                                    )}
                                </div>
                            </div>
                            <div className="book-page-form-3">
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">Condition<span className="form-required"> *</span></p>
                                    <div className="book-page-form-radio-button-container">
                                        {masterData.bookCondition.map((item) => (
                                            <div
                                                key={item.id}
                                                className="book-page-form-radio-button"
                                            >
                                                <input
                                                    type="radio"
                                                    name="condition"
                                                    id={`book-bookCondition-${item.id}`}
                                                    value={item.bookCondition}
                                                    checked={form.condition === item.bookCondition}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor={`book-bookCondition-${item.id}`}>
                                                    {item.bookCondition}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.condition && (
                                        <span className="error-msg-rad">{errors.condition}</span>
                                    )}
                                </div>
                                {form.condition === "Used Condition" && (
                                    <div className="book-page-form-radio-container">
                                        <p className="book-page-form-radio-title">Wear Level
                                            <span className="form-required">*</span>
                                        </p>
                                        <div className="book-page-form-radio-button-container">
                                            {masterData.usedCondition.map((item) => item.usedConditionType !== "Unacceptable" && (
                                                <div
                                                    key={item.id}
                                                    className="book-page-form-radio-button"
                                                >
                                                    <input
                                                        type="radio"
                                                        name="usedCondition"
                                                        id={`book-usedCondition-${item.id}`}
                                                        value={item.usedConditionType}
                                                        checked={form.usedCondition === item.usedConditionType}
                                                        onChange={handleChange}
                                                        style={{ cursor: item.usedConditionType === "Unacceptable" ? "no-drop" : "auto" }}
                                                        disabled={item.usedConditionType === "Unacceptable"}
                                                    />
                                                    <label htmlFor={`book-usedCondition-${item.id}`}>
                                                        {item.usedConditionType}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                        {errors.usedCondition && (
                                            <span className="error-msg-rad">{errors.usedCondition}</span>
                                        )}
                                    </div>
                                )}
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">Binding <span className="form-required">*</span></p>
                                    <div className="book-page-form-radio-button-container">
                                        {masterData.bookType.map((item) => (
                                            <div
                                                key={item.id}
                                                className="book-page-form-radio-button"
                                            >
                                                <input
                                                    type="radio"
                                                    name="bookType"
                                                    id={`book-Type-${item.id}`}
                                                    value={item.bookType}
                                                    checked={form.bookType === item.bookType}
                                                    onChange={handleChange}
                                                />
                                                <label htmlFor={`book-Type-${item.id}`}>
                                                    {item.bookType}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.bookType && (
                                        <span className="error-msg-rad">{errors.bookType}</span>
                                    )}
                                </div>
                                <div className="book-page-form-radio-container">
                                    <p className="book-page-form-radio-title">Book Type <span className="form-required">*</span></p>
                                    <div className="book-page-form-radio-button-container">
                                        {masterData.bookFormat.map((item) => item.format !== "Exceptions" && (
                                            <div
                                                key={item.id}
                                                className="book-page-form-radio-button"
                                            >
                                                <input
                                                    type="radio"
                                                    name="bookFormat"
                                                    id={`book-format-${item.id}`}
                                                    value={item.format}
                                                    checked={form.bookFormat === item.format}
                                                    onChange={handleChange}
                                                    style={{
                                                        cursor: (item.format === "Exceptions" || form?.bookFormat === "Exceptions")
                                                            ? "not-allowed"
                                                            : "auto"
                                                    }}
                                                />
                                                <label htmlFor={`book-format-${item.id}`}>
                                                    {item.format}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.bookFormat && (
                                        <span className="error-msg-rad">{errors.bookFormat}</span>
                                    )}
                                </div>

                                {form.bookFormat === "Exceptions" && (
                                    <div className="field-group" style={{ display: 'none' }}>
                                        <select
                                            id="reasonForException"
                                            name="reasonForException"
                                            className={getInputClass(form?.reasonForException)}
                                            value={form.reasonForException}
                                            onChange={handleChange}
                                            required
                                            style={{ cursor: "no-drop" }}
                                            disabled
                                        >
                                            <option value=""></option>

                                            {masterData.bookFormatExceptions.map((exception) => (
                                                <option key={exception.id} value={exception.id}>
                                                    {exception.exceptionType}
                                                </option>
                                            ))}
                                        </select>
                                        <label htmlFor="reasonForException" className="label">
                                            Reason for Exception{" "}
                                            <span className="form-required">*</span>
                                        </label>
                                        {errors.reasonForException && (
                                            <span className="error-msg">
                                                {errors.reasonForException}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="book-page-form-checkbox-container">
                                    <p className="book-page-form-checkbox-title">Content <span className="form-required">*</span></p>
                                    <div className="book-page-form-checkbox-button-container">
                                        {masterData.condition.map((item) => (
                                            <div
                                                key={item.id}
                                                className="book-page-form-checkbox-button"
                                            >
                                                <input
                                                    type="checkbox"
                                                    name="content"
                                                    id={`content-${item?.id}`}
                                                    value={item?.fileType}
                                                    checked={form.content?.includes(item?.fileType)}
                                                    onChange={handleContentChange}
                                                />
                                                <label htmlFor={`content-${item?.id}`}>
                                                    {item.fileType}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                    {errors.content && (
                                        <span className="error-msg-rad">{errors.content}</span>
                                    )}
                                </div>

                                <input
                                    id="weight"
                                    name="weight"
                                    className={`${"book-page-form-input-text hidden-input"} ${form.weight === "" ? "" : "has-text"
                                        }`}
                                    type="number"
                                    value={form.weight}
                                    onChange={handleChange}
                                    placeholder="Weight (grams)"
                                    hidden
                                />
                                <div className="book-page-form-scan-rack-container">
                                    <input
                                        className="book-page-form-scan-rack-button"
                                        id="rackShelf"
                                        name="rackShelf"
                                        placeholder="Enter / Scan Rack Shelf Barcode"
                                        // className={`${"book-page-form-input-text"} ${
                                        //   form.rackAndShelf === "" ? "" : "has-text"
                                        // }`}
                                        value={form.rackShelf}
                                        onChange={handleChange}
                                        required
                                    ></input>
                                    <button
                                        className="book-page-form-scan-rack-button-icon"
                                        onClick={() => setActiveScanner("Rack & Shelf ID")}
                                    >
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <circle
                                                cx="12"
                                                cy="13"
                                                r="3"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M10.0001 20H14.0001C16.809 20 18.2135 20 19.2224 19.3259C19.6591 19.0341 20.0341 18.6591 20.326 18.2223C21.0001 17.2134 21.0001 15.8089 21.0001 13C21.0001 10.1911 21 8.78685 20.3258 7.77795C20.034 7.34119 19.659 6.96619 19.2222 6.67436C18.2133 6.00023 16.8089 6.00023 14 6.00023H9.99995C7.19103 6.00023 5.78656 6.00023 4.77767 6.67436C4.34091 6.96619 3.96591 7.34119 3.67407 7.77795C3.0001 8.78663 3.0001 10.1905 3.0001 12.9982L3.0001 13C3.0001 15.8089 3.0001 17.2134 3.67422 18.2223C3.96605 18.6591 4.34106 19.0341 4.77782 19.3259C5.78671 20 7.19117 20 10.0001 20Z"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                            />
                                            <path
                                                d="M18 10H17.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M14.5 3.5H9.5"
                                                stroke="#1C274C"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M8.00098 4C8.00098 3.44772 8.41425 3 8.92405 3H15.0779C15.5877 3 16.001 3.44772 16.001 4C16.001 4.55228 15.5877 5 15.0779 5H8.92405C8.41425 5 8.00098 4.55228 8.00098 4Z"
                                                fill="url(#paint0_linear_1086_13736)"
                                            />
                                            <path
                                                fillRule="evenodd"
                                                clipRule="evenodd"
                                                d="M9.77875 21H14.2232C17.3442 21 18.9047 21 20.0257 20.2777C20.511 19.965 20.9277 19.5632 21.252 19.0953C22.001 18.0143 22.001 16.5095 22.001 13.4999C22.001 10.4903 22.0008 8.9857 21.2518 7.90473C20.9275 7.43676 20.5109 7.03497 20.0256 6.72228C18.9046 6 17.3441 6 14.223 6H9.77859C6.65756 6 5.09705 6 3.97605 6.72228C3.49077 7.03497 3.0741 7.43676 2.74984 7.90473C2.00098 8.98547 2.00098 10.4896 2.00098 13.4979L2.00098 13.4999C2.00098 16.5095 2.00098 18.0143 2.75 19.0953C3.07426 19.5632 3.49093 19.965 3.97622 20.2777C5.09721 21 6.65773 21 9.77875 21ZM7.83431 13.4999C7.83431 11.2808 9.69979 9.48196 12.001 9.48196C14.3022 9.48196 16.1676 11.2808 16.1676 13.4999C16.1676 15.7189 14.3022 17.5178 12.001 17.5178C9.69979 17.5178 7.83431 15.7189 7.83431 13.4999ZM9.50098 13.4999C9.50098 12.1685 10.6203 11.0891 12.001 11.0891C13.3817 11.0891 14.501 12.1685 14.501 13.4999C14.501 14.8313 13.3817 15.9106 12.001 15.9106C10.6203 15.9106 9.50098 14.8313 9.50098 13.4999ZM18.1121 9.48196C17.6519 9.48196 17.2788 9.84174 17.2788 10.2855C17.2788 10.7294 17.6519 11.0891 18.1121 11.0891H18.6676C19.1279 11.0891 19.501 10.7294 19.501 10.2855C19.501 9.84174 19.1279 9.48196 18.6676 9.48196H18.1121Z"
                                                fill="url(#paint1_linear_1086_13736)"
                                            />
                                            <defs>
                                                <linearGradient
                                                    id="paint0_linear_1086_13736"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                                <linearGradient
                                                    id="paint1_linear_1086_13736"
                                                    x1="22.601"
                                                    y1="11.9503"
                                                    x2="1.98296"
                                                    y2="14.3301"
                                                    gradientUnits="userSpaceOnUse"
                                                >
                                                    <stop stopColor="#033D9B" />
                                                    <stop offset="1" stopColor="#29ACD5" />
                                                </linearGradient>
                                            </defs>
                                        </svg>
                                    </button>
                                    <span className="error-msg-rad">{errors.rackShelf}</span>
                                </div>
                            </div>

                            <div className="book-page-form-4">
                                <div className="field-group">
                                    <button
                                        className="book-page-form-view-comments"
                                        onClick={() => openCommentsSlider(form.bid)}
                                        type="button"
                                    >
                                        {`View Comments (${commentsList.length})`}
                                    </button>
                                    <textarea
                                        id="comments"
                                        rows="4"
                                        value={form.comments}
                                        onChange={(e) =>
                                            setForm((prev) => ({ ...prev, comments: e.target.value }))
                                        }
                                        className={`${"book-page-form-input-textarea"} ${form.content === "" ? "" : "has-text"
                                            }`}
                                    ></textarea>
                                    <label htmlFor="comments">Comments</label>
                                </div>
                                {/* <Button type="button" onClick={saveComment}>
                  Save Comment
                </Button> */}
                            </div>
                        </div>

                        <div className="book-page-footer-container">
                            <div className="book-page-action-container">
                                <button

                                    className="book-page-queue-button"
                                    onClick={handleGoToAbout}
                                >
                                    <span>
                                        <svg
                                            width="24"
                                            height="24"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M9.5 7L4.5 12L9.5 17"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                            <path
                                                opacity="0.5"
                                                d="M4.5 12L14.5 12C16.1667 12 19.5 13 19.5 17"
                                                stroke="currentColor"
                                                strokeWidth="1.5"
                                                strokeLinecap="round"
                                            />
                                        </svg></span>Queue Page</button>
                                <div className="book-page-buttons-container">

                                    <button className="accept-button" disabled={isDisabled}>Update</button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </main>
        </>
    );
};
export default MyForm;
